<template>
	<div>
		<h1>Client Info</h1>
		<table class="table">
			<thead>
				<tr>
					<th scope="col">#</th>
					<th scope="col">ip</th>
					<th scope="col">browser</th>
					<th scope="col">Modal</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="user in users" :key="user.socket_id">
					<th scope="row">{{ user.socket_id }}</th>
					<td>{{ user.ip }}</td>
					<td>{{ user.browser }}</td>
					<!-- <td @click="handleModal()">{{ user.isModalOpen }}</td> -->
					<button type="button" class="btn btn-primary" @click="handleModal(user)">
						{{ user.isModalOpen ? "Close Modal" : "Open Modal" }}
					</button>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
	import {io} from "socket.io-client";
	import axios from "axios";
	export default {
		data() {
			return {
				socketInstance: io("process.env.SOCKET_API"),
				users: [],
			};
		},
		mounted() {
			this.getUsers();
			this.socketInstance.on("user_joined", async (user) => {
				console.log("User Joined", user);
				this.getUsers();
			});
			this.socketInstance.on("user_left", async (user) => {
				console.log("User Left", user);
				this.getUsers();
			});
			this.socketInstance.on("toggleModal", async ({user, status}) => {
				this.users = this.users.map((u) => {
					if (u.ip == user.ip) {
						u.isModalOpen = status;
					}
					return u;
				});
				console.log(this.users);
			});
		},
		methods: {
			async getUsers() {
				const {data} = await axios.get("process.env.SOCKET_API/api");
				this.users = data;
			},
			handleModal(user) {
				this.socketInstance.emit("toggleModal", {
					user: user,
					status: !user.isModalOpen,
				});
			},
		},
	};
</script>

<style></style>
